
export const publicFunClass= {
    data(){
      return{
        autoRefreshTime:'0',
        historyRefreshTime:"0",
        autoRefreshList:[{time: '0', name: '停止自动刷新'},{time: '5', name: '5秒自动刷新'},{time: '10', name: '10秒自动刷新'},{time: '15', name: '15秒自动刷新'},{time: '20', name: '20秒自动刷新'},{time: '25', name: '25秒自动刷新'},{time: '30', name: '30秒自动刷新'}],
        showPublicDialer:false,
        callUpPhone:'',
        showSendMessage:false,
        scrollbar:-1,
        historyScroll:-1,
        scrollInterval:'',
        pickerOptions: {
          shortcuts: [{
            text: '昨天',
            onClick(picker) {
              const startTime = new Date();
              startTime.setTime(startTime.getTime() - 1000 * 3600 * 24 * 1);
              const startMonth=(startTime.getMonth() + 1)<10?"0"+(startTime.getMonth() + 1):(startTime.getMonth() + 1);
              const startDate=startTime.getDate()<10?"0"+startTime.getDate():startTime.getDate();
              const start=startTime.getFullYear() + '-' + startMonth + '-' + startDate+" 00:00:00";
              const end = startTime.getFullYear() + '-' + startMonth + '-' + startDate+" 23:59:59";
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '今天',
            onClick(picker) {
              const time = new Date();
              const month=(time.getMonth() + 1)<10?"0"+(time.getMonth() + 1):(time.getMonth() + 1);
              const date=time.getDate()<10?"0"+time.getDate():time.getDate();
              const start=time.getFullYear() + '-' + month + '-' + date+" 00:00:00";
              const end = time.getFullYear() + '-' + month + '-' + date+" 23:59:59";
              picker.$emit('pick',  [start, end]);
            }
          }, {
            text: '上周',
            onClick(picker) {
              const now = new Date();
              const day = now.getDay();
              const weeks = new Array("7", "1", "2", "3", "4", "5", "6");
              const week=parseInt(weeks[day]);
              const startTime = new Date();
              startTime.setTime(startTime.getTime() - 1000 * 3600 * 24 * (week+6));
              const endTime = new Date();
              endTime.setTime(endTime.getTime() - 1000 * 3600 * 24 * week);
              const startMonth=(startTime.getMonth() + 1)<10?"0"+(startTime.getMonth() + 1):(startTime.getMonth() + 1);
              const startDate=startTime.getDate()<10?"0"+startTime.getDate():startTime.getDate();
              const endMonth=(endTime.getMonth() + 1)<10?"0"+(endTime.getMonth() + 1):(endTime.getMonth() + 1);
              const endDate=endTime.getDate()<10?"0"+endTime.getDate():endTime.getDate();
              const start=startTime.getFullYear() + '-' + startMonth + '-' + startDate+" 00:00:00";
              const end = endTime.getFullYear() + '-' + endMonth + '-' + endDate+" 23:59:59";
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '本周',
            onClick(picker) {
              const now = new Date();
              const day = now.getDay();
              const weeks = new Array("7", "1", "2", "3", "4", "5", "6");
              const week=parseInt(weeks[day]);
              const startTime = new Date();
              startTime.setTime(startTime.getTime() - 1000 * 3600 * 24 * (week-1));
              const endTime = new Date();
              endTime.setTime(startTime.getTime() + 1000 * 3600 * 24 * 6);
              const startMonth=(startTime.getMonth() + 1)<10?"0"+(startTime.getMonth() + 1):(startTime.getMonth() + 1);
              const startDate=startTime.getDate()<10?"0"+startTime.getDate():startTime.getDate();
              const endMonth=(endTime.getMonth() + 1)<10?"0"+(endTime.getMonth() + 1):(endTime.getMonth() + 1);
              const endDate=endTime.getDate()<10?"0"+endTime.getDate():endTime.getDate();
              const start=startTime.getFullYear() + '-' + startMonth + '-' + startDate+" 00:00:00";
              const end = endTime.getFullYear() + '-' + endMonth + '-' + endDate+" 23:59:59";
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '上月',
            onClick(picker) {
              const startTime = new Date();
              const currentTime = new Date();
              currentTime.setDate(0);
              let count=currentTime.getDate();
              startTime.setTime(startTime.getTime() - 1000 * 3600 * 24 * count);
              const startMonth=(startTime.getMonth() + 1)<10?"0"+(startTime.getMonth() + 1):(startTime.getMonth() + 1);
              const start=startTime.getFullYear() + '-' + startMonth + '-01' +" 00:00:00";
              const end = startTime.getFullYear() + '-' + startMonth + '-' + count+" 23:59:59";
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '本月',
            onClick(picker) {
              const startTime = new Date();
              let curMonth = startTime.getMonth()+1;// 加一是因为月份从0开始
              let curDays=startTime.getDate();
              const startMonth = curMonth < 10 ? ("0" + curMonth) : curMonth;
              curDays = curDays < 10 ? ("0" + curDays) : curDays;
              const start=startTime.getFullYear() + '-' + startMonth + '-01' +" 00:00:00";
              const end = startTime.getFullYear() + '-' + startMonth + '-' + curDays + " 23:59:59";
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '去年',
            onClick(picker) {
              const startTime = new Date();
              startTime.setTime(startTime.getTime() - 1000 * 3600 * 24 * 365);
              const start=startTime.getFullYear() + '-01-01'+" 00:00:00";
              const end = startTime.getFullYear() + '-12-31'+" 23:59:59";
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '今年',
            onClick(picker) {
              const startTime = new Date();
              const start=startTime.getFullYear() + '-01-01'+" 00:00:00";
              const end = startTime.getFullYear() + '-12-31'+" 23:59:59";
              picker.$emit('pick', [start, end]);
            }
          },]
        },
        pickerOptionsAndFuture: {
          shortcuts: [{
            text: '昨天',
            onClick(picker) {
              const startTime = new Date();
              startTime.setTime(startTime.getTime() - 1000 * 3600 * 24 * 1);
              const startMonth=(startTime.getMonth() + 1)<10?"0"+(startTime.getMonth() + 1):(startTime.getMonth() + 1);
              const startDate=startTime.getDate()<10?"0"+startTime.getDate():startTime.getDate();
              const start=startTime.getFullYear() + '-' + startMonth + '-' + startDate+" 00:00:00";
              const end = startTime.getFullYear() + '-' + startMonth + '-' + startDate+" 23:59:59";
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '今天',
            onClick(picker) {
              const time = new Date();
              const month=(time.getMonth() + 1)<10?"0"+(time.getMonth() + 1):(time.getMonth() + 1);
              const date=time.getDate()<10?"0"+time.getDate():time.getDate();
              const start=time.getFullYear() + '-' + month + '-' + date+" 00:00:00";
              const end = time.getFullYear() + '-' + month + '-' + date+" 23:59:59";
              picker.$emit('pick',  [start, end]);
            }
          }, {
              text: '明天',
              onClick(picker) {
                const startTime = new Date();
                startTime.setTime(startTime.getTime() + 1000 * 3600 * 24 * 1);
                const endTime = new Date();
                endTime.setTime(endTime.getTime() + 1000 * 3600 * 24 * 1);
                const startMonth=(startTime.getMonth() + 1)<10?"0"+(startTime.getMonth() + 1):(startTime.getMonth() + 1);
                const startDate=startTime.getDate()<10?"0"+startTime.getDate():startTime.getDate();
                const endMonth=(endTime.getMonth() + 1)<10?"0"+(endTime.getMonth() + 1):(endTime.getMonth() + 1);
                const endDate=endTime.getDate()<10?"0"+endTime.getDate():endTime.getDate();
                const start=startTime.getFullYear() + '-' + startMonth + '-' + startDate+" 00:00:00";
                const end = endTime.getFullYear() + '-' + endMonth + '-' + endDate+" 23:59:59";
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '上周',
              onClick(picker) {
                const now = new Date();
                const day = now.getDay();
                const weeks = new Array("7", "1", "2", "3", "4", "5", "6");
                const week=parseInt(weeks[day]);
                const startTime = new Date();
                startTime.setTime(startTime.getTime() - 1000 * 3600 * 24 * (week+6));
                const endTime = new Date();
                endTime.setTime(endTime.getTime() - 1000 * 3600 * 24 * week);
                const startMonth=(startTime.getMonth() + 1)<10?"0"+(startTime.getMonth() + 1):(startTime.getMonth() + 1);
                const startDate=startTime.getDate()<10?"0"+startTime.getDate():startTime.getDate();
                const endMonth=(endTime.getMonth() + 1)<10?"0"+(endTime.getMonth() + 1):(endTime.getMonth() + 1);
                const endDate=endTime.getDate()<10?"0"+endTime.getDate():endTime.getDate();
                const start=startTime.getFullYear() + '-' + startMonth + '-' + startDate+" 00:00:00";
                const end = endTime.getFullYear() + '-' + endMonth + '-' + endDate+" 23:59:59";
                picker.$emit('pick', [start, end]);
              }
            },{
              text: '本周',
              onClick(picker) {
                const now = new Date();
                const day = now.getDay();
                const weeks = new Array("7", "1", "2", "3", "4", "5", "6");
                const week=parseInt(weeks[day]);
                const startTime = new Date();
                startTime.setTime(startTime.getTime() - 1000 * 3600 * 24 * (week-1));
                const endTime = new Date();
                endTime.setTime(startTime.getTime() + 1000 * 3600 * 24 * 6);
                const startMonth=(startTime.getMonth() + 1)<10?"0"+(startTime.getMonth() + 1):(startTime.getMonth() + 1);
                const startDate=startTime.getDate()<10?"0"+startTime.getDate():startTime.getDate();
                const endMonth=(endTime.getMonth() + 1)<10?"0"+(endTime.getMonth() + 1):(endTime.getMonth() + 1);
                const endDate=endTime.getDate()<10?"0"+endTime.getDate():endTime.getDate();
                const start=startTime.getFullYear() + '-' + startMonth + '-' + startDate+" 00:00:00";
                const end = endTime.getFullYear() + '-' + endMonth + '-' + endDate+" 23:59:59";
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '下周',
              onClick(picker) {
                const now = new Date();
                const day = now.getDay();
                const weeks = new Array("7", "1", "2", "3", "4", "5", "6");
                const week=7-parseInt(weeks[day]);
                const startTime = new Date();
                startTime.setTime(startTime.getTime() + 1000 * 3600 * 24 *(week+1));
                const endTime = new Date();
                endTime.setTime(endTime.getTime() + 1000 * 3600 * 24 * (week+7));
                const startMonth=(startTime.getMonth() + 1)<10?"0"+(startTime.getMonth() + 1):(startTime.getMonth() + 1);
                const startDate=startTime.getDate()<10?"0"+startTime.getDate():startTime.getDate();
                const endMonth=(endTime.getMonth() + 1)<10?"0"+(endTime.getMonth() + 1):(endTime.getMonth() + 1);
                const endDate=endTime.getDate()<10?"0"+endTime.getDate():endTime.getDate();
                const start=startTime.getFullYear() + '-' + startMonth + '-' + startDate+" 00:00:00";
                const end = endTime.getFullYear() + '-' + endMonth + '-' + endDate+" 23:59:59";
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '上月',
              onClick(picker) {
                const startTime = new Date();
                const currentTime = new Date();
                currentTime.setDate(0);
                let count=currentTime.getDate();
                startTime.setTime(startTime.getTime() - 1000 * 3600 * 24 * count);
                const startMonth=(startTime.getMonth() + 1)<10?"0"+(startTime.getMonth() + 1):(startTime.getMonth() + 1);
                const start=startTime.getFullYear() + '-' + startMonth + '-01' +" 00:00:00";
                const end = startTime.getFullYear() + '-' + startMonth + '-' + count+" 23:59:59";
                picker.$emit('pick', [start, end]);
              }
            },{
              text: '本月',
              onClick(picker) {
                const startTime = new Date();
                let curMonth = startTime.getMonth()+1;// 加一是因为月份从0开始
                let curDays=startTime.getDate();
                const startMonth = curMonth < 10 ? ("0" + curMonth) : curMonth;
                curDays = curDays < 10 ? ("0" + curDays) : curDays;
                const start=startTime.getFullYear() + '-' + startMonth + '-01' +" 00:00:00";
                const end = startTime.getFullYear() + '-' + startMonth + '-' + curDays + " 23:59:59";
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '下月',
              onClick(picker) {
                const startTime = new Date();
                let curMonth = startTime.getMonth();
                startTime.setMonth(curMonth + 2);
                startTime.setDate(0);
                let count=startTime.getDate();
                const startMonth=(startTime.getMonth() + 1)<10?"0"+(startTime.getMonth() + 1):(startTime.getMonth() + 1);
                const start=startTime.getFullYear() + '-' + startMonth + '-01' +" 00:00:00";
                const end = startTime.getFullYear() + '-' + startMonth + '-' + count+" 23:59:59";
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '去年',
              onClick(picker) {
                const startTime = new Date();
                startTime.setTime(startTime.getTime() - 1000 * 3600 * 24 * 365);
                const start=startTime.getFullYear() + '-01-01'+" 00:00:00";
                const end = startTime.getFullYear() + '-12-31'+" 23:59:59";
                picker.$emit('pick', [start, end]);
              }
            },{
              text: '今年',
              onClick(picker) {
                const startTime = new Date();
                const start=startTime.getFullYear() + '-01-01'+" 00:00:00";
                const end = startTime.getFullYear() + '-12-31'+" 23:59:59";
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '明年',
              onClick(picker) {
                const startTime = new Date();
                startTime.setTime(startTime.getTime() + 1000 * 3600 * 24 * 365);
                const start=startTime.getFullYear() + '-01-01'+" 00:00:00";
                const end = startTime.getFullYear() + '-12-31'+" 23:59:59";
                picker.$emit('pick', [start, end]);
              }
            }
          ]
        },
        colors:[
          '#FFDAB9',
          '#79c6d8',
          '#7CCD7C',
          '#00EE00',
          '#4682B4',
          '#8B7500',
          '#FF6A6A',
          '#8B7355',
          '#CDC9A5',
          '#FF34B3',
          '#8B008B',
          '#8DB6CD',
          '#00008B',
          '#FFFACD',
          '#FFFACD'
        ],
        paramDate:{},
        agentInfo: JSON.parse(localStorage.getItem("agentInfo")),
      }
    },
    methods: {
      //获取当前时间
      getNowTime:function(){
        let date = new Date();
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        let hour = date.getHours();
        let second = date.getSeconds();
        let minute = date.getMinutes()
        if (hour >= 0 && hour <= 9) {
          hour = "0" + hour;
        }
        if (second >= 0 && second <= 9) {
          second = "0" + second;
        }
        if (minute >= 0 && minute <= 9) {
          minute = "0" + minute;
        }
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        let currentDate = date.getFullYear() + "-" + month + "-" + strDate
          + " " + hour + ":" + minute + ":" + second;
        return currentDate;
      },
      //切换刷新时间
      autoRefreshMonitor:function(){
        let val=this.autoRefreshTime;
        this.historyRefreshTime=this.autoRefreshTime;
        let that=this;
        let reg=/^[0-9]*$/;
        if(val=='0'){
          clearInterval(this.Interval);
          this.countdownTime="0";
          return false;
        }
        clearInterval(this.Interval);
        if(reg.test(val)){
          val=parseInt(val);
          this.countdownTime=parseInt(val);
          this.Interval= setInterval(() =>{
            that.initCountdown();
          },1000);
        }
      },
      initCountdown:function () {
        this.countdownTime=this.countdownTime-1;
        if(this.countdownTime==0){
          this.countdownTime=parseInt(this.autoRefreshTime);
          this.autoRefresh();
          return false;
        }
      },
      getSearchTime:function(sign){
        let data= 0;
        if(sign=='2'){
          data= 1000 * 3600 * 24 * 6;
        }
        if(sign=='3'){
          data= 1000 * 3600 * 24 * 29;
        }
        let startTime = new Date();
        startTime.setTime(startTime.getTime() - data);
        let endTime = new Date();
        let startMonth=(startTime.getMonth() + 1)<10?"0"+(startTime.getMonth() + 1):(startTime.getMonth() + 1);
        let startDate=startTime.getDate()<10?"0"+startTime.getDate():startTime.getDate();
        let endMonth=(endTime.getMonth() + 1)<10?"0"+(endTime.getMonth() + 1):(endTime.getMonth() + 1);
        let endDate=endTime.getDate()<10?"0"+endTime.getDate():endTime.getDate();
        let start=startTime.getFullYear() + '-' + startMonth + '-' + startDate+" 00:00:00";
        let end = endTime.getFullYear() + '-' + endMonth + '-' + endDate+" 23:59:59";
        return start+","+end
      },
      getSelectedId:function(selection){
        this.checkIds=[];
        for (let i=0;i<selection.length;i++){
          this.checkIds.push(selection[i].id)
        }
      },
      timeChange:function(time){
        let month=(time.getMonth() + 1)<10?"0"+(time.getMonth() + 1):(time.getMonth() + 1);
        let Date=time.getDate()<10?"0"+time.getDate():time.getDate();
        let Hours=time.getHours()<10?"0"+time.getHours():time.getHours();
        let Minutes=time.getMinutes()<10?"0"+time.getMinutes():time.getMinutes();
        let Seconds=time.getSeconds()<10?"0"+time.getSeconds():time.getSeconds();
        let datetime=time.getFullYear() + '-' + month + '-' + Date+' '+Hours+ ':' +Minutes+ ':' +Seconds;
        return datetime
      },
      getDate:function(time,sign){
        let month=(time.getMonth() + 1)<10?"0"+(time.getMonth() + 1):(time.getMonth() + 1);
        let Date=time.getDate()<10?"0"+time.getDate():time.getDate();
        return time.getFullYear() + '-' + month + '-' + Date+" "+sign
      },
      handleReset () {
        let searchList=this.formValidate.searchList;
        let seniorList=this.formValidate.seniorList;
        for (let i=0;i<searchList.length;i++){
          let type=searchList[i].type;
          if(type=='cascade'){
            this.formValidate.searchList[i].customValue=[];
          }else {
            this.formValidate.searchList[i].customValue="";
          }
        }
        for (let j=0;j<seniorList.length;j++){
          let type=seniorList[j].type;
          if(type=='cascade'){
            this.formValidate.seniorList[j].customValue=[];
          }else {
            this.formValidate.seniorList[j].customValue="";
          }
        }
      },
      //计算屏幕高度
      mountHeight:function (reduceHeight) {
        let clientHeight=document.documentElement.clientHeight;
        let actualHeight=clientHeight-reduceHeight+'px';
        return actualHeight;
      },
      //跳转至某一页
      handleCurrentPage:function(){
        if(!this.speedChangePage){
          this.speedChangePage=1;
        }
        let reg=/^[0-9]*$/;
        if(!reg.test(this.speedChangePage)){
          this.$Modal.info({
            title:'提示',
            content:"只能输入数字"
          });
          return false;
        }
        let pageCount=Math.ceil(this.total/this.pageSize);
        if(this.speedChangePage>pageCount && this.speedChangePage != 1){
          this.$Message.info("不能超过当前最大页面,已自动查询最后一页")
          this.speedChangePage=pageCount;
        }
        if(this.speedChangePage==0){
          this.speedChangePage=1;
        }
        this.changeCurrent(parseInt(this.speedChangePage));
      },
      //设备信息当前页改变
      changeCurrent(event) {
        this.currentPage=event;
        this.initSearch();
      },
      //设备信息页面显示数量改变
      changeSize(event) {
        this.currentPage=1;
        this.pageSize=event;
        this.initSearch();
      },
      //列表复选框全选
      checkedAllList:function(){
        if (this.checkedAll){
          for (let i = 0; i < this.infoTableList.length; i++) {
            let id=this.infoTableList[i].id;
            this.singleCheckedList.push(id);
          }
          return false;
        }
        this.singleCheckedList=[];
      },
      //设备树初始化
      initTree:function (id) {
        let setting = {
          view: {
            dblClickExpand: false,
            showLine: true,
            selectedMulti: false
          },
          check: {
            enable: true,
            chkStyle: "checkbox",
            chkboxType: { "Y": "ps", "N": "s" },
            autoCheckTrigger: true,
            chkDisabledInherit: true
          },
          data: {
            simpleData: {
              enable:true,
              idKey: "id",
              pIdKey: "pid",
              rootPId: ""
            },
            key:{
              checked:'checked'
            }
          }
        };
        let zNodes =this.inspectTreeData;
        if (zNodes){
          $(document).ready(function(){
            $.fn.zTree.init($("#"+id), setting, zNodes);//t:用于展现 zTree 的 DOM 容器,setting:zTree 的配置数据,zNodes:zTree 的节点数据
          });
        }
      },
      initPublicBtn:function (start,end,menuId) {
        let roleList=JSON.parse(localStorage.getItem("roleList"));
        for (let i = start; i < end; i++) {
          let index=menuId+i;
          if (roleList[index]){
            this.showPublicBtn=true;
          }
        }
      },
      getParam:function(formValidate,param,exportSign){
        if('taskCustom' == exportSign){
          param.taskId = this.paramDate.taskId;
          param.taskType = this.paramDate.taskType;
          param.customerScope = '';
          param.customerState = '';
        }
        let searchList=formValidate.searchList;
        let seniorList=formValidate.seniorList;
        let list=searchList.concat(seniorList);
        for (let i=0;i<list.length;i++){
          let customValue=list[i].customValue;
          if(customValue){
            customValue = customValue.toString();
          }
          let customColName=list[i].customColName;
          let customType=list[i].type;
          if(customColName=="customerType" && customValue){
            param[list[i].customColName]=customValue;
          }
          if(customColName!="customerType"){
            param[list[i].customColName]=customValue;
          }
          if (customType=="datetime") {
            param[list[i].customColName]="";
            if(customValue){
              param[list[i].customColName]=customValue.toString();
            }
          }
          if (customType=="cascade") {
            param[list[i].customColName]="";
            if(customValue.length>0){
              param[list[i].customColName]=customValue.toString();
            }
          }
        }
      },
      getDictValue:function (id) {
        let that=this;
        let param={
          dictCode:id+"",
          journalType:"null",
          menuId:"null"
        };
        this.$http.post("custom/dicts.json",param) .then(function (res) {
          let result=res.data.flag;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            that.dictList=[];
            return false;
          }
          that.dictList=res.data.obj;
        });
      },
      publicSearch:function(url,param,index){
        let that=this;
        let phoneIsHide= this.configInfo.phoneIsHide;
        let phoneOwnership= this.configInfo.phoneOwnership;
        this.queryParam = param;
        this.$http.post(url,param) .then(function (res) {
          let result=res.data.flag;
          that.spinShow=false;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.contentList=res.data.obj.list.content;
          let fieldList=res.data.obj.fields;
          let count=0;
          for (let j=0;j<fieldList.length;j++) {
            let customIsShow=fieldList[j].customIsShow;
            if(customIsShow=='1'){
              count++;
            }
          }
          that.tableCount=count;
          that.checkIds=[];
          let paramList=[];
          let seniorList=[];
          let allColumnInfo=[];
          let countFix=1;
          that.total=res.data.obj.list.totalSize;
          that.fieldList = [];
          for (let i=0;i<fieldList.length;i++){
            let customIsSearch=fieldList[i].customIsSearch;
            let customColName=fieldList[i].customColName;
            let customIsSystem=fieldList[i].customIsSystem;
            let customColSource=fieldList[i].customColSource;
            // 公海客户没有客户经理
            if(param.customerState == '1' && customColName.indexOf('customerManager') != -1){
             continue;
            }
            let customName=fieldList[i].customName;
            let customType=fieldList[i].customType;
            let customIsMust=fieldList[i].customIsMust;
            let customIsShow=fieldList[i].customIsShow;
            let customIsAlter=fieldList[i].customIsAlter;
            let countOne = 11;
            if(0 == index){
              countOne = 10;
            }
            if(paramList.length+index>countOne && customIsSearch=='1'){
                customIsSearch='2';
            }
            if(customColName=="customerId"){
              customColName="customerName";
            }
            if(customColName=="employeeId"){
              customColName="employeeName";
            }
            let tableHead={
              title: customName,
              key: customColName,
              customIsSystem:customIsSystem,
              customColSource:customColSource,
              height:40
            };

            if(count>10){
              tableHead["width"]="150";
              if(customIsShow=='1' && countFix<4){
                countFix++;
                tableHead["fixed"]=true
              }
            }
            if(customIsShow=='1'){
              if(customColName.indexOf("telephone")!=-1 || customColName.indexOf("Telephone")!=-1){
                if(phoneIsHide=='1'){
                  tableHead.key=customColName+"Hide";
                }
                that.fieldList.push(tableHead);
                if(phoneOwnership=='1'){
                  let tableHead1={
                    title: customName+"归属地",
                    key: customColName+"Address",
                    customIsSystem:customIsSystem,
                    customColSource:customColSource,
                    height:40
                  };
                  if(count>10){
                    tableHead1["width"]="150";
                    if(customIsShow=='1' && countFix<4){
                      countFix++;
                      tableHead1["fixed"]=true
                    }
                  }
                  that.fieldList.push(tableHead1);
                }
              }else {
                that.fieldList.push(tableHead);
              }
            }
            let columnParam={
              type: customType,
              customColName: customColName,
              customValue:customType=='cascade'?[]:'',
              popCustomValue:customType=='cascade'?[]:'',
              checkName:"customValue",
              customIsMust:customIsMust,
              customName:customName,
              customIsSearch:customIsSearch,
              customIsAlter:customIsAlter,
              customIsSystem:customIsSystem,
              customColSource:customColSource,
              list:fieldList[i].list,
            };
            allColumnInfo.push(columnParam);
            if(customIsSearch=='1'){
              if(!(that.customerType && customColName=="customerType")){
                paramList.push(columnParam);
              }
            }
            if(customIsSearch=='2'){
              seniorList.push(columnParam);
            }
          }
          let searchParam=that.formValidate.searchList;
          for (let i=0;i<paramList.length;i++){
            let colName=paramList[i].customColName;
            for (let j=0;j<searchParam.length;j++){
              let name=searchParam[j].customColName;
              if(colName==name){
                paramList[i].customValue=searchParam[j].customValue
              }
            }
          }
          let seniorParam=that.formValidate.seniorList;
          for (let m=0;m<seniorList.length;m++){
            let colName=seniorList[m].customColName;
            for (let n=0;n<seniorParam.length;n++){
              let name=seniorParam[n].customColName;
              if(colName==name){
                seniorList[m].customValue=seniorParam[n].customValue
              }
            }
          }
          that.formValidate.searchList=paramList;
          that.formValidate.seniorList=seniorList;
          that.formValidate.allColumnInfo=allColumnInfo;
          let length=(paramList.length+index)>6?2:1;
          let height=length*40;
          that.searchHeight.height= height+"px";
          let clientHeight=document.documentElement.clientHeight;
          that.tableHeight=clientHeight-132-height;
          if (that.showPublicBtn) {
            that.tableHeight=clientHeight-182-height;
          }
        });
      },
      returnClassName:function(event){
        let sendMessageFlag=localStorage.getItem("sendMessageFlag");
        //普通员工或仅支持在线客服的座席如果没有开启短信，页面无蓝色超链
        if(('1' == this.agentInfo.employeeType || this.agentInfo.isSupportChat == '2')&& '0' == sendMessageFlag){
          return '';
        }
        if(event.column.property){
          if(event.column.property.toLowerCase().indexOf("telephone")!=-1 && event.column.property.indexOf("Address")==-1){
            return 'telephone'
          }
          if(event.column.property.indexOf("callerNum")!=-1){
            return 'telephone'
          }
          if(event.column.property.toLowerCase().indexOf("phone")!=-1 && event.column.property.indexOf("Address")==-1){
            return 'telephone'
          }
          if(event.column.property.toLowerCase().indexOf('caller')!=-1 && event.row.callType.indexOf('呼入')!=-1){
            return 'telephone'
          }
          if(event.column.property.toLowerCase().indexOf('callee')!=-1 && event.row.callType.indexOf('呼出')!=-1){
            return 'telephone'
          }
          if (event.column.property.toLowerCase().indexOf('file') != -1) {
            return 'telephone'
          }
        }
      },
      reportCallScreen:function(row, column){
        if(column.property){
          let phone=row[column.property+"Hide"];
          if (!phone) {
            phone = row[column.property]
          }
          if(column.property.toLowerCase().indexOf("telephone")!=-1 && column.property.indexOf('Address')==-1){
            this.messageOrPhone(phone);
            return;
          }
          if(column.property.toLowerCase().indexOf("phone")!=-1 && column.property.indexOf('telephoneOneAddress')==-1){
            this.messageOrPhone(phone);
            return;
          }
          if (column.property.indexOf('callerNum') != -1 && row.callType.indexOf('呼入') != -1) {
            this.messageOrPhone(phone);
            return false;
          }
          if (column.property.indexOf('calleeNum') != -1 && row.callType.indexOf('呼出') != -1) {
            this.messageOrPhone(phone);
            return false;
          }
          if (column.property.indexOf('caller') != -1 && row.callType.indexOf('呼入') != -1) {
            this.messageOrPhone(phone);
          }
          if (column.property.indexOf('callee') != -1 && row.callType.indexOf('呼出') != -1) {
            this.messageOrPhone(phone);
          }
          if (column.property.indexOf('rwName') != -1) {
            if (row['rwName'].indexOf('AI助手记录') != -1) {
              this.showAIPop = true;
              this.callUuid = row['callUuid'];
            } else if (row['rwName'] == "") {
              return false;
            }else {
              this.openFlowDetail = true;
              this.callUuid = row['callUuid'];
            }
          }
        }
      },
      openCallScreen:function(row, column){
        if(column.property){
          let phone = row[column.property];
          if(column.property.indexOf("Hide")!=-1){
            phone = row[column.property.substring(0, column.property.length - 4)]
          }
          if (column.property.toLowerCase().indexOf("telephone") != -1 && column.property.indexOf('Address') == -1) {
            this.messageOrPhone(phone);
            return;
          }
          if (column.property.toLowerCase().indexOf("phone") != -1 && column.property.indexOf('telephoneOneAddress') == -1) {
            this.messageOrPhone(phone);
            return;
          }
          if (column.property.indexOf('callerNum') != -1) {
            this.messageOrPhone(phone);
          }
        }
      },
      openPopTelScreen:function(row, column){
        this.$emit("openTel",row, column);
      },
      messageOrPhone:function(phone){
        let that=this;
        let sendMessageFlag=localStorage.getItem("sendMessageFlag");
        //为普通员工且短信未开启，以下步骤跳过
        if(('1' == that.agentInfo.employeeType || that.agentInfo.isSupportChat == '2') && '0' == sendMessageFlag){
          return;
        }
        if(phone.indexOf("(")!=-1){
          phone=phone.substring(0,phone.indexOf("("));
        }
        that.callUpPhone=phone;
        //为普通员工，且短信功能已开启
        if(('1' == that.agentInfo.employeeType || that.agentInfo.isSupportChat == '2') && '1' == sendMessageFlag){
          that.showSendMessage=true;
          return;
        }
        if(!phone) {
          return false;
        }
        let signinStatus=localStorage.getItem("signinStatus");
        if(sendMessageFlag=='0'){
          if(signinStatus=='0'){
            this.$Message.info("请先签入");
            return false;
          }
          this.$emit("openCallPhone",true,phone,'1');
          return false;
        }
        this.$confirm('请选择发送短信或者拨打电话', '提示', {
          distinguishCancelAndClose: true,
          confirmButtonText: '拨打电话',
          cancelButtonText: '发送短信'
        }).then(() => {
            if(signinStatus=='0'){
              that.$Message.info("请先签入");
              return false;
            }
          if (phone) {
              that.$emit("openCallPhone",true,phone,'1');
            }
          })
          .catch(action => {
            if(action === 'cancel'){
              that.showSendMessage=true;
            }
          });
      },
      changeHidePhone:function(fieldList){
        for (let i=0;i<fieldList.length;i++){
           let key=fieldList[i].key;
           if(key=='callerNum'){
              fieldList[i].key='callerNumHide';
           }
          if(key=='calleeNum'){
            fieldList[i].key='calleeNumHide';
          }
          if(key=='caller'){
            fieldList[i].key='callerHide';
          }
          if(key=='callee'){
            fieldList[i].key='calleeHide';
          }
        }
        return fieldList;
      },
      showColor:function(event){
        if(event.column.property){
          if(event.column.property.indexOf("callerNum")!=-1 && event.row.callType.indexOf('呼入')!=-1){
            return 'telephone'
          }
          if(event.column.property.indexOf("calleeNum")!=-1 && event.row.callType.indexOf('呼出')!=-1){
            return 'telephone'
          }
          if(event.column.property.indexOf("caller")!=-1 && event.row.callType.indexOf('呼入')!=-1){
            return 'telephone'
          }
          if(event.column.property.indexOf("callee")!=-1 && event.row.callType.indexOf('呼出')!=-1){
            return 'telephone'
          }
          if (event.column.property.indexOf('rwName') != -1) {
            return 'telephone'
          }
        }
      },
      //关闭发送短信弹窗
      closeSendMessage:function(){
        this.showSendMessage=false;
      },
      //关闭公共电话弹窗
      closePublicDialerPage:function(flag,phone){
        if(!flag){
          this.showPublicDialer=false;
        }
        if(flag){
          this.$emit("openCallPhone",flag,phone,'1');
        }
      },
      getStartTime:function (event) {
        this.startTime=event;
      },
      getEndTime:function (event) {
        this.endTime=event;
      },
      getPstnNumber:function (type) {
        let that=this;
        let param={
          type:type,
          journalType:"null",
          menuId:"null"
        };
        this.$http.post("employee/getPstnNumber.json",param) .then(function (res) {
          let result=res.data.flag;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.pstnNumberList=res.data.obj.list;
        });
      },
      //设备树初始化
      initKnowledgeTree:function (id) {
        let that=this;
        let setting = {
          view: {
            dblClickExpand: false,
            showLine: true,
            selectedMulti: false
          },
          data: {
            simpleData: {
              enable:true,
              idKey: "id",
              pIdKey: "pid",
              rootPId: ""
            }
          },
          callback: {
            onClick: zTreeOnClick
          }
        };
        function zTreeOnClick(event,treeId,treeNode) {
          that.selectedTreeId=treeNode.id;
          if(id=='knowledgeTree'){
            that.initSearch("1");
          }else {
            that.initSearch();
          }
        }
        let zNodes =this.inspectTreeData;
        if (zNodes){
          $(document).ready(function(){
            $.fn.zTree.init($("#"+id), setting, zNodes);//t:用于展现 zTree 的 DOM 容器,setting:zTree 的配置数据,zNodes:zTree 的节点数据
          });
        }
        // 打开后仍有选中效果
        // console.log
        let ztree = $.fn.zTree.getZTreeObj("knowledgeTree");
        var node = ztree.getNodesByParam("id",that.selectedTreeId);
        ztree.selectNode(node[0]);

      },
      initSearchTree:function (treeId) {
        let that=this;
        let paramTwo={
          name:"根类目",
          pid : "null",
          id : "0",
          open:true,
        };
        let param={
          type:"0",
          journalType:"null",
          menuId:"null"
        };
        this.$http.post("knowledge/toLevelIndex.json",param) .then(function (res) {
          let result=res.data.flag;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.inspectTreeData=res.data.obj.tree;
          that.inspectTreeData.push(paramTwo);
          that.initKnowledgeTree(treeId);
        });
      },
      getQueue:function (isTwo,flag) {
        let that=this;
        let param={
          journalType:"null",
          menuId:"null",
        };
        this.$http.post("pstnNumber/queryQueueNameList.json",param) .then(function (res) {
          let result=res.data.flag;
          if(result!="666"){
            that.$alert(res.data.msg, '提示', {
              confirmButtonText: '确定'
            });
            return false;
          }
          if (isTwo) {
            let list = res.data.obj.queueNameList;
            if (list) {
              let arr1 = []
              let arr2 = []
              list.forEach(l=>{
                if (l.queueType==='0'){
                  arr1.push(l)
                }else if (l.queueType === '1') {
                  arr2.push(l)
                }
              })
              if (isTwo === '0') {
                that.queueList = arr1;
              }else if (isTwo === '1') {
                that.queueList = arr2;
              } else {
                that.queueList = arr1;
                that.queueList2 = arr2;
              }
            }
          } else {
            that.queueList=res.data.obj.queueNameList;
          }
          if(flag){
            //技能组的编辑弹窗需要将自己去除
            for (let i = 0;i < that.queueList.length;i++){
              if(that.skillId == that.queueList[i].id){
                that.queueList.splice(i,1);
                break;
              }
            }
          }
        });
      },
      handleScroll () {
        let that=this;
        this.$refs.selection.bodyWrapper.addEventListener('scroll', (res) => {
          clearInterval(that.scrollInterval);
          that.scrollbar=res.timeStamp;
          that.historyScroll=res.timeStamp;
          that.tableClass=false;
          that.scrollInterval= setInterval(() =>{
            if(that.scrollbar==that.historyScroll){
              clearInterval(that.scrollInterval);
              that.tableClass=true;
              clearInterval(that.scrollInterval);
            }
          },1000);
        },true);
      },
      //获取AI流程
      getAIWorkFlow() {
        let that = this
        let param = {
          rwName:'',
          rtId:'',
        }
        this.$http.post('/AI/WorkFlow/queryList',param).then(res=>{
          let response = res.data
          if(response.flag!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.aiFlow = response.obj.content
        })
      },
      assembleTree(data) {
        let result = []
        if(!Array.isArray(data)) {
          return result
        }
        let map = {};
        data.forEach(item => {
          map[item.id] = item;
        });
        data.forEach(item => {
          let parent = map[item.parentId];
          if(parent) {
            (parent.children || (parent.children = [])).push(item);
          } else {
            result.push(item);
          }
        });
        return result;
      },
      // 日期格式化
      formatDate: function(time, fmt){
        return fmt.replace("yyyy",time.getFullYear()).replace("MM",time.getMonth()+1).replace("dd",time.getDate())
               .replace("hh",(time.getHours() < 10 ? "0" + time.getHours() : time.getHours()))
               .replace("mm",(time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes()))
               .replace("ss",(time.getSeconds() < 10 ? "0" + time.getSeconds() : time.getSeconds()))
      },
      // 时间格式转换，把昨天的时间修改成昨天两字，今年的日期不显示年，今天的时间不显示月份
      timeFormat: function(customTime){
        let time = new Date();
        // 今年1号的零点
        let yearStart = this.formatDate(time,"yyyy") + "-1-1 00:00:00";

        customTime= new Date(Date.parse(customTime));
        yearStart= new Date(Date.parse(yearStart));
        if(customTime > yearStart){  //今年
        // 今天的零点
        let todayStart = this.formatDate(time,"yyyy-MM-dd") + " 00:00:00";
          todayStart= new Date(Date.parse(todayStart));
          if(customTime > todayStart){  //今天
             return this.formatDate(customTime,"hh:mm:ss");
          }else{ //昨天或以前
            let yesterdayStart = todayStart.getTime() - 24*60*60*1000; //昨天零点
            if(customTime.getTime() < yesterdayStart){ //比昨天更早的时间
              return this.formatDate(customTime,"MM-dd hh:mm:ss");
            }else{
              return "昨天    " + this.formatDate(customTime,"hh:mm:ss");
            }

          }
        }else{ //去年
          return this.formatDate(customTime,"yyyy-MM-dd hh:mm:ss");
        }
      },
      // 将秒转换成时分秒
      formatSeconds: function(seconds){
        if(!seconds){
          seconds = 0;
        }
        let theTime = parseInt(seconds);// 秒
        let middle= 0;// 分
        let hour= 0;// 小时

        if(theTime > 60) {
            middle= parseInt(theTime / 60);
            theTime = parseInt(theTime % 60);
            if(middle> 60) {
                hour= parseInt(middle / 60);
                middle= parseInt(middle % 60);
            }
        }
        let result = ":"+(parseInt(theTime) < 10 ? "0"+parseInt(theTime) : parseInt(theTime));
        if(middle > 0) {
            result = ":"+(parseInt(middle) < 10 ? "0"+parseInt(middle) : parseInt(middle)) + result;
        }else{
          result = ":00" + result;
        }
        if(hour> 0) {
            result = (parseInt(hour) < 10 ? "0" + parseInt(hour) : parseInt(hour)) + result;
        }else{
          result = "00" + result;
        }
        return result;
      },
      //一般数组去重
      arrayDeDuplication:function (array) {
        for(let i=0; i<array.length; i++){
          for(let j=i+1; j<array.length; j++){
            if(array[i] == array[j]){
              array.splice(j,1);
              j--;
            }
          }
        }
        return array;
      },

      // 快捷词获取,获取后转成map存入session中
      chatReplyWorkAndContent:function(){
        let param = {

        }
        this.$http.post("chatReply/toChatReplyWorkAndContent.json",param) .then(function (res) {
          let result=res.data.flag;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          localStorage.setItem("ChatReplyWorkAndContent",JSON.stringify(res.data.obj.list));
        });
      }
    },
    watch:{
      starEndTime:function () {
        if(!this.starEndTime){
          this.starEndTime=[];
        }
      },
      currentPage:function () {
        this.speedChangePage= this.currentPage;
      },
      total:function () {
        if(this.total<=this.pageSize){
          this.speedChangePage=1;
          this.currentPage=1;
        }
      }
    }
};




// WEBPACK FOOTER //
// ./src/components/js/PublicFunClass.js